// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"bf920d79","503":"741f536c","710":"0a2542c3","911":"7946717b"}[chunkId] + ".chunk.js";
};